import { Grid, Box, Button } from "@material-ui/core"
import { useSnackbar } from "notistack"
import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { useData } from "../common/DataProvider"
import { useEsriModules } from "../common/useEsriModules"
import { DisplayFieldSetting } from "./DisplayFieldSetting"
import { getFeatureLayerRestUrl } from "./esriDefinitionHelpers"

/** SettingsEditor component props */
interface SettingsEditorProps {}

/** Refactor me when you add more settings */
export const SettingsEditor: FunctionComponent<SettingsEditorProps> = () => {
  /** Grab the active feature layer */
  const {
    activeFeatureLayer: [featureLayer],
  } = useData()

  /** Set up the form */
  const methods = useForm()

  /** Grab the request esri module for use */
  const [request] = useEsriModules<[typeof __esri.request]>(["esri/request"])

  /** Update the deinfition on submit */
  const { enqueueSnackbar } = useSnackbar()
  const handleFormSubmit = (values: any) => {
    const body = new FormData()
    body.append("f", "json")
    body.append("updateDefinition", JSON.stringify(values))
    // use esriRequest to perform a rest request
    request &&
      featureLayer &&
      request(getFeatureLayerRestUrl(featureLayer) + "/updateDefinition", {
        responseType: "json",
        authMode: "immediate",
        method: "post",
        body,
      })
        .then(() =>
          enqueueSnackbar(`Definition saved for ${featureLayer.title}`, {
            variant: "success",
          })
        )
        .catch(error => {
          enqueueSnackbar("Error saving the definition", {
            variant: "error",
          })
          console.log(error)
        })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={8}>
            <DisplayFieldSetting />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box position="sticky" top={16}>
              <Button type="submit" variant="contained" color="secondary">
                Save settings
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}
